import React from 'react'
import Layout from '../../Layout'
import AddFactorContainer from '../../../../Components/Factor/AddFactorContainer/AddFactorContainer'

const AddFactor = () => {
  return (
   <Layout><AddFactorContainer/></Layout>
  )
}

export default AddFactor